const PHRASES = [
  "IMMERSIVE AT HOME",
  "POST-DELIVERED THEATRE",
  "EPISODE ONE — THE SÉANCE",
  "LIMITED NUMBERED EDITIONS",
  "UNBOX THE UNEXPLAINED",
  "BY CANDLELIGHT ONLY",
];

export const Marquee = () => {
  const row = [...PHRASES, ...PHRASES];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-gold/10 bg-surface/40 py-6"
    >
      <div className="flex w-max animate-marquee items-center gap-12 whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-12" aria-hidden={half === 1}>
            {row.map((phrase, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-12">
                <span className="font-cinzel text-sm tracking-[0.35em] text-sand/70">
                  {phrase}
                </span>
                <span className="text-[10px] text-gold/60">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
